import { SxProps, Theme } from '@mui/material';

/**
 * Base chrome for selectable panel rows (master–detail / sidebar lists).
 * Hover lifts the panel with a directional shadow while preserving its border.
 */
export const selectablePanelRootSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  p: 1.5,
  gap: 1.5,
  border: 1,
  borderColor: 'divider',
  borderRadius: 1,
  bgcolor: 'background.paper',
  textAlign: 'left',
  color: 'text.primary',
  cursor: 'pointer',
  transition: 'all 0.15s ease-in-out',
  '&:hover': {
    bgcolor: 'action.hover',
    borderColor: 'divider',
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  },
};

/**
 * Selected state stays grounded and uses an inset anchor without layout shift.
 */
export const selectablePanelSelectedSx: SxProps<Theme> = {
  bgcolor: 'action.hover',
  borderColor: 'divider',
  boxShadow: (theme) => `inset 4px 0 0 0 ${theme.palette.primary.main}`,
  cursor: 'default',
  transform: 'none',
  '&:hover': {
    bgcolor: 'action.hover',
    borderColor: 'divider',
    boxShadow: (theme) => `inset 4px 0 0 0 ${theme.palette.primary.main}`,
    transform: 'none',
  },
};
